import {
  Button,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
} from '@chakra-ui/react';
import * as React from 'react';

import { EDigestPreference } from '@/graphql-types/globalTypes';

import { DIGEST_PREFERENCE_OPTIONS } from './shared/util';

type IUserDigestSettingsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  value: EDigestPreference;
  onChange: (digestPreference: EDigestPreference) => Promise<void>;
  loading?: boolean;
  modalHeader: string;
  formLabel: string;
};

export const UserDigestSettingsModal: React.FC<
  IUserDigestSettingsModalProps
> = (props) => {
  const [digestPreference, setDigestPreference] = React.useState(props.value);

  React.useEffect(() => {
    setDigestPreference(props.value);
  }, [props.value]);

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{props.modalHeader}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <FormLabel>{props.formLabel}</FormLabel>
            <Select
              value={digestPreference}
              onChange={(event) =>
                setDigestPreference(event.target.value as EDigestPreference)
              }
            >
              {DIGEST_PREFERENCE_OPTIONS.map((digestPreferenceOption) => (
                <option
                  key={digestPreferenceOption.value}
                  value={digestPreferenceOption.value}
                >
                  {digestPreferenceOption.text}
                </option>
              ))}
            </Select>
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button
            isLoading={props.loading}
            onClick={async () => {
              await props.onChange(digestPreference);
              props.onClose();
            }}
          >
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
